(function () {
    var cacheTTL = 10 * 60 * 1000;
    var sessionKey = 'itg-availability-cache-v1';
    var memoryCache = new Map();
    var inFlightCache = new Map();
    var persistTimer = null;

    function normalizeLocationTokens(locationValue) {
        return String(locationValue || '')
            .split(',')
            .map(function (entry) {
                return entry.trim().toLowerCase();
            })
            .filter(Boolean);
    }

    function buildCacheKey(variantId, shippingFromLocation) {
        return String(variantId) + '::' + normalizeLocationTokens(shippingFromLocation).join('|');
    }

    function initSessionCache() {
        try {
            var raw = window.sessionStorage.getItem(sessionKey);
            if (!raw) return;
            var parsed = JSON.parse(raw);
            var now = Date.now();
            Object.keys(parsed).forEach(function (key) {
                var entry = parsed[key];
                if (!entry || entry.expiresAt <= now) return;
                memoryCache.set(key, entry);
            });
        } catch (_error) {
            // Ignore cache hydration errors.
        }
    }

    function pruneExpiredEntries(now) {
        memoryCache.forEach(function (entry, key) {
            if (!entry || entry.expiresAt <= now) {
                memoryCache.delete(key);
            }
        });
    }

    function persistSessionCache() {
        try {
            var now = Date.now();
            pruneExpiredEntries(now);
            var payload = {};
            memoryCache.forEach(function (entry, key) {
                if (!entry || entry.expiresAt <= now) return;
                payload[key] = entry;
            });
            window.sessionStorage.setItem(sessionKey, JSON.stringify(payload));
        } catch (_error) {
            // Ignore cache persistence errors.
        }
    }

    function schedulePersistSessionCache() {
        if (persistTimer !== null) {
            return;
        }

        persistTimer = window.setTimeout(function () {
            persistTimer = null;
            persistSessionCache();
        }, 0);
    }

    function isAvailableForLocation(locationData, shippingFromLocation) {
        var locationString = String(locationData || '').toLowerCase();
        var requestedLocations = normalizeLocationTokens(shippingFromLocation);
        if (!requestedLocations.length || locationString === 'false') {
            return false;
        }

        return requestedLocations.some(function (locationName) {
            return locationString.indexOf(locationName) !== -1;
        });
    }

    function fetchVariantAvailability(variantId, shippingFromLocation) {
        var parsedVariantId = parseInt(variantId, 10);
        var normalizedVariantId = Number.isNaN(parsedVariantId) ? String(variantId) : parsedVariantId;
        var cacheKey = buildCacheKey(normalizedVariantId, shippingFromLocation);
        var now = Date.now();

        var cachedEntry = memoryCache.get(cacheKey);
        if (cachedEntry && cachedEntry.expiresAt > now) {
            return Promise.resolve(cachedEntry.value);
        }

        if (cachedEntry) {
            memoryCache.delete(cacheKey);
            schedulePersistSessionCache();
        }

        if (inFlightCache.has(cacheKey)) {
            return inFlightCache.get(cacheKey);
        }

        var variantSectionUrl =
            '/variants/' +
            normalizedVariantId +
            '/?section_id=helper-pickup-availability-extended';

        var requestPromise = fetch(variantSectionUrl)
            .then(function (response) {
                return response.text();
            })
            .then(function (text) {
                var sectionInnerHTML = new DOMParser()
                    .parseFromString(text, 'text/html')
                    .querySelector('.shopify-section');

                var variantAvailabilityEl = sectionInnerHTML
                    ? sectionInnerHTML.querySelector('#variant-availability')
                    : null;

                var resolvedVariantId = variantAvailabilityEl
                    ? variantAvailabilityEl.getAttribute('data-variant-id')
                    : null;

                if (resolvedVariantId == null || resolvedVariantId === '') {
                    resolvedVariantId = normalizedVariantId;
                }

                var locationData = variantAvailabilityEl
                    ? variantAvailabilityEl.getAttribute('data-location')
                    : null;

                var available = isAvailableForLocation(locationData, shippingFromLocation);

                return {
                    variantId: parseInt(resolvedVariantId, 10) || normalizedVariantId,
                    available: available ? 'true' : 'false',
                };
            })
            .then(function (result) {
                memoryCache.set(cacheKey, {
                    value: result,
                    expiresAt: Date.now() + cacheTTL,
                });
                schedulePersistSessionCache();
                return result;
            })
            .catch(function () {
                return {
                    variantId: normalizedVariantId,
                    available: 'false',
                };
            })
            .finally(function () {
                inFlightCache.delete(cacheKey);
            });

        inFlightCache.set(cacheKey, requestPromise);
        return requestPromise;
    }

    function writeAvailabilityScript(scriptId, values) {
        var serialized = JSON.stringify(
            values.map(function (value) {
                if (!value || typeof value !== 'object') {
                    return value;
                }

                var variantId = value.variantId != null ? value.variantId : value['variant-id'];
                if (variantId == null) {
                    return value;
                }

                var normalizedValue = {};
                Object.keys(value).forEach(function (key) {
                    normalizedValue[key] = value[key];
                });
                normalizedValue.variantId = variantId;
                normalizedValue['variant-id'] = variantId;
                return normalizedValue;
            })
        );
        var existing = document.getElementById(scriptId);
        if (existing) {
            existing.type = 'application/json';
            existing.textContent = serialized;
            return;
        }

        var body = document.body;
        if (!body) {
            return;
        }

        var script = document.createElement('script');
        script.id = scriptId;
        script.type = 'application/json';
        script.textContent = serialized;
        body.appendChild(script);
    }

    function applyDeliveryStatus(element, isAvailable, deliverySuccess, deliveryError) {
        var isDrawer = element.getAttribute('data-drawer') === 'true';

        element.classList.remove('alert--circle-loading', 'alert--note');
        if (isAvailable) {
            element.classList.remove('alert--error', 'unavailable-delivery');
            element.classList.add('alert--success');
            if (!isDrawer) {
                element.textContent = deliverySuccess;
            }
            return;
        }

        element.classList.remove('alert--success');
        element.classList.add('alert--error', 'unavailable-delivery');
        if (!isDrawer) {
            element.textContent = deliveryError;
        }
    }

    function runLimited(tasks, concurrency) {
        if (!tasks.length) {
            return Promise.resolve();
        }

        var index = 0;
        var workers = [];
        var workerCount = Math.max(1, Math.min(concurrency, tasks.length));

        var runWorker = function () {
            if (index >= tasks.length) {
                return Promise.resolve();
            }

            var taskIndex = index;
            index += 1;
            return Promise.resolve(tasks[taskIndex]()).then(runWorker, runWorker);
        };

        for (var i = 0; i < workerCount; i++) {
            workers.push(runWorker());
        }

        return Promise.allSettled(workers);
    }

    function getVisiblePriorityMap(elements) {
        var priorityMap = new Map();
        elements.forEach(function (element) {
            var rect = element.getBoundingClientRect();
            if (rect.top < window.innerHeight + 300 && rect.bottom > -300) {
                priorityMap.set(element, true);
            }
        });
        return priorityMap;
    }

    function sortItemsByPriority(items, priorityMap) {
        items.sort(function (left, right) {
            var leftPriority = priorityMap.has(left.element) ? 1 : 0;
            var rightPriority = priorityMap.has(right.element) ? 1 : 0;
            return rightPriority - leftPriority;
        });

        return items;
    }

    function isCollectionTemplate() {
        return document.body && document.body.classList.contains('template-collection');
    }

    async function checkAvailITG() {
        var shippingLocationElement = document.querySelector('.shipping-available-location-name');
        if (!shippingLocationElement) {
            return Promise.resolve();
        }

        var shippingFromLocation = shippingLocationElement.getAttribute('data-location-name') || '';
        var deliverySuccess = document.body ? document.body.getAttribute('data-delivery-success') : '';
        var deliveryError = document.body ? document.body.getAttribute('data-delivery-error') : '';
        var completionTasks = [];

        var shippingElements = Array.from(document.querySelectorAll('[data-shipping-id], [data-shipping-item-id]'));
        if (shippingElements.length) {
            completionTasks.push(
                (async function () {
                    var variantIds = shippingElements
                        .map(function (element) {
                            return element.getAttribute('data-shipping-id') || element.getAttribute('data-shipping-item-id');
                        })
                        .filter(Boolean);

                    if (!variantIds.length) {
                        return;
                    }

                    var results = await Promise.all(
                        variantIds.map(function (variantId) {
                            return fetchVariantAvailability(variantId, shippingFromLocation);
                        })
                    );

                    writeAvailabilityScript('itg-shipping-availability', results);

                    var resultByVariant = {};
                    results.forEach(function (result) {
                        resultByVariant[String(result.variantId)] = result;
                    });

                    document.querySelectorAll('[data-shipping-id]').forEach(function (element) {
                        var variantId = element.getAttribute('data-shipping-id');
                        var matched = resultByVariant[String(variantId)];
                        if (!matched) {
                            return;
                        }

                        applyDeliveryStatus(
                            element,
                            matched.available === 'true',
                            deliverySuccess,
                            deliveryError
                        );
                    });
                })()
            );
        }

        var listShippingElements = Array.from(document.querySelectorAll('[data-list-shipping-id]'));
        if (listShippingElements.length) {
            completionTasks.push(
                (async function () {
                    var items = listShippingElements
                        .map(function (element) {
                            var variantIdsRaw = element.getAttribute('data-list-shipping-id');
                            var productId = element.getAttribute('data-product-id');
                            if (!variantIdsRaw || !productId) {
                                return null;
                            }

                            return {
                                element: element,
                                productId: productId,
                                variantIds: String(variantIdsRaw)
                                    .split(',')
                                    .map(function (id) {
                                        return id.trim();
                                    })
                                    .filter(Boolean),
                            };
                        })
                        .filter(Boolean);

                    if (!items.length) {
                        return;
                    }

                    var priorityMap = isCollectionTemplate()
                        ? getVisiblePriorityMap(
                              items.map(function (item) {
                                  return item.element;
                              })
                          )
                        : new Map();

                    sortItemsByPriority(items, priorityMap);

                    var aggregateResults = [];
                    var tasks = items.map(function (item) {
                        return async function () {
                            var isAvailableForProduct = false;

                            for (var i = 0; i < item.variantIds.length; i++) {
                                var result = await fetchVariantAvailability(item.variantIds[i], shippingFromLocation);
                                aggregateResults.push(result);

                                if (result.available === 'true') {
                                    isAvailableForProduct = true;
                                    break;
                                }
                            }

                            applyDeliveryStatus(item.element, isAvailableForProduct, deliverySuccess, deliveryError);
                        };
                    });

                    await runLimited(tasks, 4);
                    writeAvailabilityScript('itg-item-shipping-availability', aggregateResults);
                })()
            );
        }

        if (!completionTasks.length) {
            return Promise.resolve();
        }

        return Promise.allSettled(completionTasks);
    }

    window.itgAvailabilityResolver = {
        initSessionCache: initSessionCache,
        fetchVariantAvailability: fetchVariantAvailability,
    };

    if (typeof window !== 'undefined' && window.__INTERNAL_TEST_MODE__) {
        window.itgAvailabilityResolver.__test__ = {
            buildCacheKey: buildCacheKey,
            persistSessionCache: persistSessionCache,
            writeAvailabilityScript: writeAvailabilityScript,
            runLimited: runLimited,
            sortItemsByPriority: sortItemsByPriority,
            primeMemoryCache: function (variantId, shippingFromLocation, entry) {
                memoryCache.set(buildCacheKey(variantId, shippingFromLocation), entry);
            },
            clearMemoryCache: function () {
                memoryCache.clear();
            },
            primeInFlightCache: function (variantId, shippingFromLocation, promise) {
                inFlightCache.set(buildCacheKey(variantId, shippingFromLocation), promise);
            },
            clearInFlightCache: function () {
                inFlightCache.clear();
            },
        };
    }

    window.itgCheckAvailITG = checkAvailITG;

    initSessionCache();
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            checkAvailITG();
        }, { once: true });
    } else {
        checkAvailITG();
    }
})();
